import { PokerGameModel, UserProfileModel } from 'mvppoker-portal-common/api'
import React from 'react'
import { FriendsListItem, FriendsListItemActions } from './FriendsListItem'
import './FriendsModal.scss'

export interface FriendsModalViewProps
{
	friends: UserProfileModel[],
    rooms: { [roomId: string] : PokerGameModel },
	unreadChats: { [userId: string] : boolean },

	clickRefresh: () => void,
	isRefreshing: boolean,
	friendsListItemActions: FriendsListItemActions,
}

export const FriendsModalView : React.FC<FriendsModalViewProps> = ({ friends, rooms, unreadChats, clickRefresh, isRefreshing, friendsListItemActions }) =>
{
	const items = friends.map((friend) => <FriendsListItem key={friend.userId} friend={friend} hasUnreadChat={unreadChats[friend.userId] === true} rooms={rooms} {...friendsListItemActions} />)
	const hasFriends = items.length > 0

	return (
		<>
			<span className='modal-title-l'>FRIENDS</span>
			{hasFriends && <div id='friends-list'>
				{items}
			</div>}
			{!hasFriends && <p className="prompt">YOU HAVE NO FRIENDS AT THE MOMENT.<br/><br/>GO PLAY POKER<br/>HAVE FUN<br/>AND MAKE SOME FRIENDS!</p>}
		</>
	)
}
